import { render, staticRenderFns } from "./PayPalStandard.vue?vue&type=template&id=35b30687&scoped=true"
import script from "./PayPalStandard.vue?vue&type=script&lang=js"
export * from "./PayPalStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b30687",
  null
  
)

export default component.exports